import { call, put, all, takeEvery } from 'redux-saga/effects';
import moment from 'moment';
import { atpApi } from 'config/axios';
import { gcApi } from 'config/axios';
import {
    FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT,
    FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT_SUCCESS,
    FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT_ERROR,
    FETCH_RESCHEDULE_DAYS,
    FETCH_RESCHEDULE_DAYS_SUCCESS,
    FETCH_ADAPTIVE_PLAN_CALENDAR,
    FETCH_ADAPTIVE_PLAN_CALENDAR_SUCCESS,
    FETCH_ADAPTIVE_PLAN_CALENDAR_ERROR,
    REQUEST_ATP_TYPES,
    REQUEST_ATP_TYPES_SUCCESS,
    REQUEST_ATP_ACTIVE,
    REQUEST_ATP_ACTIVE_SUCCESS,
    REQUEST_ATP_COMPLETED,
    REQUEST_ATP_COMPLETED_SUCCESS,
    FETCH_ADAPTIVE_PLAN,
    FETCH_ADAPTIVE_PLAN_SUCCESS,
    FETCH_ADAPTIVE_PLAN_ERROR,
    FETCH_COACH_PLAN,
    FETCH_COACH_PLAN_SUCCESS,
    FETCH_COACH_PLAN_ERROR,
    FETCHING_ADAPTIVE_PLAN_NEXT_WORKOUT,
    FETCHING_ADAPTIVE_PLAN_CALENDAR,
    FETCH_PLAN_CONTENT,
    FETCH_PLAN_CONTENT_SUCCESS,
    FETCH_PLAN_CONTENT_ERROR,
    FETCH_COACH_CAUTION,
    FETCH_COACH_CAUTION_SUCCESS,
    FETCH_COACH_CAUTION_ERROR,
    FETCH_PREPLAN_DISTANCE,
    FETCH_PREPLAN_DISTANCE_SUCCESS,
    FETCH_PREPLAN_DISTANCE_ERROR,
    FETCH_PREPLAN_PACE,
    FETCH_PREPLAN_PACE_SUCCESS,
    FETCH_PREPLAN_PACE_ERROR,
    FETCH_PREPLAN_GOALS,
    FETCH_PREPLAN_GOALS_SUCCESS,
    FETCH_PREPLAN_GOALS_ERROR,
    FETCH_PREPLAN_PACE_TIMES,
    FETCH_PREPLAN_PACE_TIMES_SUCCESS,
    FETCH_PREPLAN_PACE_TIMES_ERROR,
    FETCH_PREPLAN_COACHES,
    FETCH_PREPLAN_COACHES_SUCCESS,
    FETCH_PREPLAN_COACHES_ERROR,
    REQUEST_ATP_ACTIVE_FETCHING,
    REQUEST_ATP_ACTIVE_FAIL
} from '../../actions/ActionTypes';
import {
    PAUSE_ATP_PLAN,
    RESUME_ATP_PLAN,
    REACT_TO_COACH,
    QUIT_ATP_PLAN
} from '../../actions/adaptiveTrainingPlanActions';
import {
    updateAtpPlanStatusAction,
    updateAtpPlanStatusSuccessAction,
    updateAtpPlanStatusErrorAction
} from '../../actions/adaptiveTrainingPlanActions';
import { handlingErrorCallback, handlingSuccessCallback } from 'sagas/sagasUtils';

// worker
export function* fetchAdaptivePlanNextWorkout(action) {
    try {
        const { athletePlanId } = action.payload;
        yield put({
            type: FETCHING_ADAPTIVE_PLAN_NEXT_WORKOUT
        });

        const response = yield call(atpApi.get, `/atp/athlete/nextWorkout?athletePlanId=${athletePlanId}`);
        let workoutResponse;

        if (response && response.data) {
            const workoutScheduleId = response.data.scheduleWorkoutId;
            workoutResponse = yield call(gcApi.get, `/workout-service/schedule/${workoutScheduleId}`);
        }

        yield put({
            type: FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT_SUCCESS,
            atpNextWorkout: response && response.data ? response.data : {},
            atpWorkout: workoutResponse && workoutResponse.data ? workoutResponse.data : {}
        });
    } catch (e) {
        yield put({
            type: FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT_ERROR,
            atpNextWorkout: {},
            atpWorkout: {},
            error: e
        });
    }
}

export function* fetchAdaptivePlanCalendar(action) {
    try {
        const { athletePlanId, startDate, endDate, lang } = action.payload;

        yield put({
            type: FETCHING_ADAPTIVE_PLAN_CALENDAR
        });

        const calResponse = yield call(
            atpApi.get,
            `/atp/athlete/calendar?athletePlanId=${athletePlanId}&startDate=${startDate}&endDate=${endDate}&lang=${lang}`
        );
        const calendar = calResponse.data;

        if (calendar) {
            let callArray = []; //array of call promises

            //build array of promises
            Object.keys(calendar).map((key) => {
                const workoutScheduleId = calendar[key].scheduleWorkoutId;
                if (workoutScheduleId) {
                    callArray.push(call(gcApi.get, `/workout-service/schedule/${workoutScheduleId}`));
                }
            });

            const workoutResponses = yield all(callArray); //call to workout-service in parallel

            Object.keys(calendar).map((key) => {
                if (workoutResponses[key]) {
                    calendar[key].workoutName = workoutResponses[key].data.workout.workoutName;
                }
            });
        }

        yield put({
            type: FETCH_ADAPTIVE_PLAN_CALENDAR_SUCCESS,
            atpCalendar: calendar
        });
    } catch (e) {
        yield put({
            type: FETCH_ADAPTIVE_PLAN_CALENDAR_ERROR,
            error: e
        });
    }
}

export function* fetchRescheduleDays(action) {
    try {
        const { athletePlanId, startDate, endDate, lang } = action.payload;

        yield put({
            type: FETCHING_ADAPTIVE_PLAN_CALENDAR
        });

        const response = yield call(
            atpApi.get,
            `/atp/athlete/calendar?athletePlanId=${athletePlanId}&startDate=${startDate}&endDate=${endDate}&lang=${lang}`
        );

        yield put({
            type: FETCH_RESCHEDULE_DAYS_SUCCESS,
            atpRescheduleDays: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_ADAPTIVE_PLAN_CALENDAR_ERROR,
            error: e
        });
    }
}

export function* fetchPlanTypes(action) {
    try {
        const lang = action.payload;
        const response = yield call(atpApi.get, `/atp/types/?lang=${lang || 'en'}`);

        yield put({
            type: REQUEST_ATP_TYPES_SUCCESS,
            atpPlanTypes: response.data
        });
    } catch (e) {
        // Handling Error
    }
}

export function* fetchActivePlans() {
    try {
        const response = yield call(atpApi.get, '/atp/athlete/active');

        yield put({
            type: REQUEST_ATP_ACTIVE_FETCHING
        });

        yield put({
            type: REQUEST_ATP_ACTIVE_SUCCESS,
            activePlans: response.data
        });
    } catch (e) {
        yield put({
            type: REQUEST_ATP_ACTIVE_FAIL,
            data: null
        });
    }
}

export function* fetchCompletedPlans(action) {
    try {
        const response = yield call(atpApi.get, '/atp/athlete/completed');

        yield put({
            type: REQUEST_ATP_COMPLETED_SUCCESS,
            completedPlans: response.data
        });
    } catch (e) {
        // Handling Error
    }
}

export function* fetchAdaptivePlan(action) {
    try {
        const { athletePlanId, lang, callback } = action.payload;
        const response = yield call(atpApi.get, `/atp/athlete/plan?athletePlanId=${athletePlanId}&lang=${lang}`);

        yield put({
            type: FETCH_ADAPTIVE_PLAN_SUCCESS,
            atpPlan: response.data
        });

        if (callback) {
            yield call(handlingSuccessCallback, callback, response);
        }
    } catch (e) {
        yield put({
            type: FETCH_ADAPTIVE_PLAN_ERROR,
            error: e,
            action: action
        });

        if (action.payload.callback) {
            yield call(handlingErrorCallback, action.payload.callback, e);
        }
    }
}

/**
 * Get an ATP coach plan by workoutPlanId
 * @param action: action object containing workoutPlanId and lang
 */
export function* fetchCoachPlan(action) {
    try {
        const { workoutPlanId, lang } = action.payload;
        const response = yield call(atpApi.get, `/atp/setup/plan?workoutPlanId=${workoutPlanId}&lang=${lang}`);

        yield put({
            type: FETCH_COACH_PLAN_SUCCESS,
            coachPlan: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_COACH_PLAN_ERROR,
            error: e,
            action: action
        });
    }
}

export function* pauseAtpPlan({ athletePlanId, callback }) {
    try {
        const response = yield atpApi.post(`/atp/athlete/pause?athletePlanId=${athletePlanId}`);

        yield put(updateAtpPlanStatusSuccessAction(response, 'pause'));

        if (callback) {
            yield call(handlingSuccessCallback, callback, response);
        }
    } catch (e) {
        yield put(updateAtpPlanStatusErrorAction(e));

        if (callback) {
            yield call(handlingErrorCallback, callback, e);
        }
    }
}

export function* unPauseAtpPlan({ athletePlanId, reason, callback }) {
    try {
        const response = yield atpApi.post(`/atp/athlete/unpause/${reason}?athletePlanId=${athletePlanId}`);

        yield put(updateAtpPlanStatusSuccessAction(response, 'unpause'));

        yield call(handlingCallback, callback, response);
    } catch (e) {
        yield put(updateAtpPlanStatusErrorAction(e));
    }
}

export function* reactToCoach({ athletePlanId, actionId, actionOptionId, callback }) {
    try {
        yield put(updateAtpPlanStatusAction({ athletePlanId: athletePlanId, planStatus: 'react' }));

        const reaction = {
            athletePlanId: athletePlanId,
            reaction: {
                actionId: actionId,
                actionOptionId: actionOptionId,
                reactionDate: new moment().format(moment.HTML5_FMT.DATETIME_LOCAL_MS)
            }
        };

        const response = yield atpApi.post('/atp/athlete/react', reaction);
        yield put(updateAtpPlanStatusSuccessAction(response));

        yield call(handlingCallback, callback, response);
    } catch (e) {
        yield put(updateAtpPlanStatusErrorAction(e));
    }
}

export function* quitAtpPlan({ athletePlanId, callback }) {
    try {
        yield put(updateAtpPlanStatusAction({ athletePlanId: athletePlanId }));

        const response = yield atpApi.post(`/atp/athlete/quit?athletePlanId=${athletePlanId}`);

        yield put(updateAtpPlanStatusSuccessAction(response, 'quit'));

        yield call(handlingCallback, callback, response);
    } catch (e) {
        yield put(updateAtpPlanStatusErrorAction(e));
    }
}

export function* completeAtpPlan({ athletePlanId, callback }) {
    try {
        yield put(updateAtpPlanStatusAction({ athletePlanId: athletePlanId, planStatus: 'complete' }));

        const response = yield atpApi.post('/atp/athlete/complete');

        yield put(updateAtpPlanStatusSuccessAction(response));

        yield call(handlingCallback, callback, response);
    } catch (e) {
        yield put(updateAtpPlanStatusErrorAction(e));
    }
}

function handlingCallback(callback, response) {
    if (callback && callback.onSuccess) {
        callback.onSuccess(response.data);
    }
}

export function* fetchPlanContent({ workoutPlanTypeId, lang }) {
    try {
        const response = yield call(
            atpApi.get,
            `/atp/types/content?workoutPlanTypeId=${workoutPlanTypeId}&lang=${lang}`
        );
        yield put({
            type: FETCH_PLAN_CONTENT_SUCCESS,
            data: response.data,
            workoutPlanTypeId: workoutPlanTypeId
        });
    } catch (e) {
        yield put({
            type: FETCH_PLAN_CONTENT_ERROR,
            error: e
        });
    }
}

export function* fetchCoachCaution({
    planTypeId,
    prePlanWeeklyMileage,
    prePlanTrainingPace,
    selectedGoal,
    selectedPaceGoalTime,
    callback
}) {
    let params = {
        planTypeId,
        prePlanWeeklyMileage,
        prePlanTrainingPace
    };
    if (selectedGoal) {
        params.selectedGoal = selectedGoal;
    }
    if (selectedPaceGoalTime) {
        params.selectedPaceGoalTime = selectedPaceGoalTime;
    }
    try {
        const response = yield call(atpApi.post, `/atp/setup/coachCaution`, params);
        yield put({
            type: FETCH_COACH_CAUTION_SUCCESS,
            data: response.data
        });

        if (callback) {
            yield call(handlingSuccessCallback, callback, response);
        }
    } catch (e) {
        yield put({
            type: FETCH_COACH_CAUTION_ERROR,
            error: e
        });

        if (callback) {
            yield call(handlingErrorCallback, callback, e);
        }
    }
}

export function* fetchPreplanDistance({ workoutPlanTypeId, unitType }) {
    try {
        const response = yield call(
            atpApi.get,
            `/atp/setup/prePlanMileage?workoutPlanTypeId=${workoutPlanTypeId}&unitType=${unitType}`
        );
        yield put({
            type: FETCH_PREPLAN_DISTANCE_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_PREPLAN_DISTANCE_ERROR,
            error: e
        });
    }
}

export function* fetchPreplanPace({ workoutPlanTypeId, unitType }) {
    try {
        const response = yield call(
            atpApi.get,
            `/atp/setup/prePlanTrainingPace?workoutPlanTypeId=${workoutPlanTypeId}&unitType=${unitType}`
        );
        yield put({
            type: FETCH_PREPLAN_PACE_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_PREPLAN_PACE_ERROR,
            error: e
        });
    }
}

export function* fetchPreplanGoals({ workoutPlanTypeId, prePlanTrainingPace, prePlanWeeklyMileage, lang }) {
    try {
        const response = yield call(
            atpApi.get,
            `/atp/setup/goals?planTypeId=${workoutPlanTypeId}&prePlanTrainingPace=${prePlanTrainingPace}&prePlanWeeklyMileage=${prePlanWeeklyMileage}&lang=${lang}`
        );
        yield put({
            type: FETCH_PREPLAN_GOALS_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_PREPLAN_GOALS_ERROR,
            error: e
        });
    }
}

export function* fetchPreplanPaceTimes({ workoutPlanTypeId, prePlanWeeklyMileage, prePlanTrainingPace, lang }) {
    try {
        const response = yield call(
            atpApi.get,
            `/atp/setup/paceTimes?${
                workoutPlanTypeId ? 'planTypeId=' + workoutPlanTypeId + '&' : ''
            }&prePlanTrainingPace=${prePlanTrainingPace}&prePlanWeeklyMileage=${prePlanWeeklyMileage}&lang=${lang}`
        );
        yield put({
            type: FETCH_PREPLAN_PACE_TIMES_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_PREPLAN_PACE_TIMES_ERROR,
            error: e
        });
    }
}

export function* fetchPreplanCoaches({
    workoutPlanTypeId,
    goal,
    raceGoalTime,
    prePlanWeeklyMileage,
    prePlanTrainingPace,
    lang,
    callback
}) {
    try {
        const response = yield call(
            atpApi.get,
            `/atp/setup/plans?planTypeId=${workoutPlanTypeId}&lang=${lang}&goal=${goal}${
                raceGoalTime ? '&raceGoalTime=' + raceGoalTime : ''
            }&prePlanWeeklyMileage=${prePlanWeeklyMileage}&prePlanTrainingPace=${prePlanTrainingPace}`
        );
        if (callback) {
            yield call(handlingSuccessCallback, callback, response);
        } else {
            yield put({
                type: FETCH_PREPLAN_COACHES_SUCCESS,
                data: response.data
            });
        }
    } catch (e) {
        if (callback) {
            yield call(handlingErrorCallback, callback, e);
        } else {
            yield put({
                type: FETCH_PREPLAN_COACHES_ERROR,
                error: e
            });
        }
    }
}

// watcher
export const atpSagas = [
    takeEvery(FETCH_ADAPTIVE_PLAN_NEXT_WORKOUT, fetchAdaptivePlanNextWorkout),
    takeEvery(FETCH_RESCHEDULE_DAYS, fetchRescheduleDays),
    takeEvery(FETCH_ADAPTIVE_PLAN_CALENDAR, fetchAdaptivePlanCalendar),
    takeEvery(REQUEST_ATP_TYPES, fetchPlanTypes),
    takeEvery(REQUEST_ATP_ACTIVE, fetchActivePlans),
    takeEvery(REQUEST_ATP_COMPLETED, fetchCompletedPlans),
    takeEvery(FETCH_ADAPTIVE_PLAN, fetchAdaptivePlan),
    takeEvery(FETCH_COACH_PLAN, fetchCoachPlan),
    takeEvery(PAUSE_ATP_PLAN, pauseAtpPlan),
    takeEvery(RESUME_ATP_PLAN, unPauseAtpPlan),
    takeEvery(REACT_TO_COACH, reactToCoach),
    takeEvery(QUIT_ATP_PLAN, quitAtpPlan),
    takeEvery(FETCH_PLAN_CONTENT, fetchPlanContent),
    takeEvery(FETCH_COACH_CAUTION, fetchCoachCaution),
    takeEvery(FETCH_PREPLAN_DISTANCE, fetchPreplanDistance),
    takeEvery(FETCH_PREPLAN_PACE, fetchPreplanPace),
    takeEvery(FETCH_PREPLAN_GOALS, fetchPreplanGoals),
    takeEvery(FETCH_PREPLAN_PACE_TIMES, fetchPreplanPaceTimes),
    takeEvery(FETCH_PREPLAN_COACHES, fetchPreplanCoaches)
];
